// Vuex connections module actions

import { API } from '@/config';

import {
  FILL_LIST,
  SET_PAGE,
} from './mutations-types';

export default {

  async getList({ commit }) {
    try {
      const { records, total } = (await API.get('/addressbook/getList')).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },

  async addNumber(context, params) {
    try {
      await API.put('/addressbook/addNumber', params);
    } catch (err) {
      console.log(err);
    }
  },

  async removeNumber(context, params) {
    try {
      await API.patch('/addressbook/removeNumber', params);
    } catch (err) {
      console.log(err);
    }
  },

  async updateNumber(context, params) {
    try {
      await API.patch('/addressbook/updateNumber', params);
    } catch (err) {
      console.log(err);
    }
  },

  changePage({ commit }, page) {
    commit(SET_PAGE, { page });
  },
};
